import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ledger">
        <div className="text-navy/55 font-sans text-sm">Lade …</div>
      </div>
    );
  }

  if (!user) {
    // Wenn der Interceptor (lib/api.js) wegen 401 ein Flag gesetzt hat,
    // hängen wir ?session=expired an, damit Login den Hinweis-Banner zeigt.
    let qs = "";
    try {
      if (window.sessionStorage.getItem("session_expired") === "1") {
        const next = encodeURIComponent(location.pathname + location.search);
        qs = `?session=expired&next=${next}`;
      }
    } catch { /* ignore */ }
    return <Navigate to={`/login${qs}`} state={{ from: location.pathname }} replace />;
  }

  if (requireAdmin && user.rolle !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
}
